// extracted by mini-css-extract-plugin
module.exports = {"main_container":"heroSection_main_container__lFEDG","desktop_container":"heroSection_desktop_container__cFdRq","mobile_container":"heroSection_mobile_container__AiKFa"};